import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CompareIcon from '@mui/icons-material/Compare';
import MovieIcon from '@mui/icons-material/Movie';
import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import StoryMenu from './story-menu.jsx';
import Typography from '@mui/material/Typography';
import clockTime from 'clock-time';
import format from 'date-fns/format';
import {ASPECT_RATIO} from '../../../constants.js';
import {ASSETS_URL} from '../../../config.js';
import {Link as RouterLink} from 'react-router-dom';
import {styled} from '@mui/material/styles';
import {theme} from '../../../styles.js';

// The use of React.forwardRef will no longer be required for react-router-dom v6.
// See https://github.com/ReactTraining/react-router/issues/6056
const LinkButton = React.forwardRef((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
));

const Media = styled(CardMedia)({
  height: 0,
  paddingTop: `${(1 / ASPECT_RATIO) * 100}%`,
  backgroundColor: theme.palette.common.black,
});

const StyledCardContent = styled(CardContent)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});

const CardContentText = styled('div')({
  flexGrow: 1,
  overflow: 'hidden',
});

const Subheading = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'pre',
});

class StoryCard extends Component {
  static propTypes = {
    story: PropTypes.object.isRequired,
  };

  renderStoryLength() {
    if (this.props.story.format !== 'mp4') {
      return null;
    }

    const storyLength = this.props.story.frames.length / this.props.story.rate;
    return (
      <Fragment>
        <span> / </span>
        <span title={`${Math.round(storyLength)} seconds`}>
          {clockTime(storyLength * 1000)}
        </span>
      </Fragment>
    );
  }

  render() {
    const createdDate = new Date(this.props.story.created);

    return (
      <Fragment>
        <Card data-cy="story-card" sx={{position: 'relative'}}>
          <CardActionArea component={LinkButton} to={`/${this.props.story.id}`}>
            <Media
              image={`${ASSETS_URL}/${this.props.story.id}/frame-000.png`}
              title={this.props.story.title}
              data-cy="story-image"
            />
          </CardActionArea>
          <StyledCardContent>
            <CardContentText>
              <Typography
                noWrap
                title={this.props.story.title}
                variant="body1"
                gutterBottom
                data-cy="story-title"
              >
                {this.props.story.title}
              </Typography>
              <Subheading variant="caption" color="textSecondary">
                {this.props.story.format === 'mp4' ? (
                  <MovieIcon fontSize="small" />
                ) : (
                  <CompareIcon fontSize="small" />
                )}
                <span
                  title={format(createdDate, "MMMM d, yyyy 'at' h:mm a")}
                  data-cy="story-date-label"
                  style={{marginLeft: 4}}
                >
                  {format(createdDate, 'MMMM d, yyyy')}
                </span>
                {this.renderStoryLength()}
              </Subheading>
            </CardContentText>
            {this.props.story.own && <StoryMenu story={this.props.story} />}
          </StyledCardContent>
        </Card>
      </Fragment>
    );
  }
}

export default StoryCard;
